<template>
    <div>
        <portal-section title="公司综览" style="max-height: 332px;">
            <div class="yq-company-monitor-company-list-container">
                <div class="yq-company-monitor-company-list">
                    <div v-for="mcs in allMonitoredCompanySummaries" :key="mcs.id" class="yq-company-monitor-company"
                         @click="showCompany(mcs.companyId)">
                        <img class="yq-company-monitor-company-logo" :src="mcs.companyLogoUrl">
                        <div class="yq-company-monitor-company-info">
                            <div class="yq-company-monitor-company-name">{{mcs.companyName}}</div>
                            <div class="yq-company-monitor-company-events">{{mcs.eventCount}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </portal-section>
        <portal-section title="风险变动统计" style="margin-top: 14px;height: 332px;">
            <v-chart style="width: 100%;height: 100%;" v-if="countEventAndCompanyMonthlyChart" :options="countEventAndCompanyMonthlyChart.options"
                     :init-options="countEventAndCompanyMonthlyChart.initOptions" autoresize theme="dark"></v-chart>
        </portal-section>
        <el-row :gutter="20" style="margin-top: 14px;">
            <el-col :span="12">
                <portal-section title="最新风险事件" style="height: 332px">
                    <el-timeline class="yq-company-monitor-timeline">
                        <el-timeline-item v-for="event in companyRiskEvents.content" :key="event.id" :timestamp="event.publishDate" hide-timestamp>
                            <div class="yq-company-monitor-timeline-event">
                                <div class="yq-company-monitor-timeline-event-time">
                                    <pretty-date-time :value="event.publishDate" format="YYYY-MM-DD"></pretty-date-time>
                                </div>
                                <div class="yq-company-monitor-timeline-event-company">
                                    <el-link @click="showCompany(event.companyId)" type="primary">{{event.companyName}}</el-link>
                                </div>
                                <div class="yq-company-monitor-timeline-event-type">
                                    <el-link @click="openEventPage(event)" type="primary">{{event.type}}</el-link>
                                </div>
                            </div>
                        </el-timeline-item>
                    </el-timeline>
                    <infinite-loading :identifier="infiniteId" @infinite="loadCompanyRiskEvents">
                        <div slot="spinner">加载中...</div>
                        <div slot="no-more">没有更多了</div>
                        <div slot="no-results">暂无数据</div>
                    </infinite-loading>
                </portal-section>
            </el-col>
            <el-col :span="12">
                <portal-section title="风险上升排行" style="height: 332px">
                    <el-table class="yq-table" :data="allMonitoredCompanySummaries" style="width: 100%" max-height="260">
                        <el-table-column type="index" label="序号"></el-table-column>
                        <el-table-column prop="companyName" label="公司名称">
                            <el-link slot-scope="scope" @click="showCompany(scope.row.companyId)" type="primary">{{scope.row.companyName}}</el-link>
                        </el-table-column>
                        <el-table-column prop="eventCount" label="风险事件上涨数" width="120"></el-table-column>
                        <el-table-column prop="totalEventCount" label="当前风险事件数" width="120"></el-table-column>
                    </el-table>
                </portal-section>
            </el-col>
        </el-row>
        <portal-section title="关联企业风险" style="margin-top: 14px;">
            <el-table v-if="relationCompanySummaries" class="yq-table" :data="relationCompanySummaries.content"
                      style="width: 100%" max-height="350">
                <el-table-column
                        label="序号"
                        type="index"
                        :index="relationCompanySummariesIndexMethod" width="60">
                </el-table-column>
                <el-table-column
                        prop="relationCompanyName"
                        label="相关公司">
                    <el-link slot-scope="scope" @click="showCompany(scope.row.relationCompanyId)" type="primary">{{scope.row.relationCompanyName}}</el-link>
                </el-table-column>
                <el-table-column
                        prop="mainCompanyName"
                        label="关注公司">
                    <el-link slot-scope="scope" @click="showCompany(scope.row.mainCompanyId)" type="primary">{{scope.row.mainCompanyName}}</el-link>
                </el-table-column>
                <el-table-column
                        prop="relationType"
                        label="关联类型" width="100">
                </el-table-column>
                <el-table-column
                        prop="eventCount"
                        label="风险事件数" width="100">
                    <pretty-date-time slot-scope="scope" :value="scope.row.expiredAt" format="YYYY-MM-DD"/>
                </el-table-column>
                <el-table-column
                        label="最近风险项" width="120">
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.lastEvent" @click="openEventPage(scope.row.lastEvent)" type="primary">{{scope.row.lastEvent.type}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column
                        label="最近变动时间" width="120">
                    <span slot-scope="scope">{{scope.row.lastEvent?scope.row.lastEvent.publishDate:''}}</span>
                </el-table-column>
                <el-table-column
                        label="添加关注" width="100" v-if="canAdmin">
                    <template slot-scope="scope">
                        <span v-if="scope.row.followed">已关注</span>
                        <el-link v-else type="primary" @click="addMonitoredCompany(scope.row)">关注</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-if="relationCompanySummaries"
                    layout="prev, pager, next" background
                    :total="relationCompanySummaries.totalElements" :current-page="relationCompanySummaries.number+1"
                    @current-change="fetchData($event)" style="margin: 10px auto 0;">
            </el-pagination>
        </portal-section>
    </div>
</template>

<script>
    import PortalSection from '../common/PortalSection'
    import companyMonitorService from '../../service/company_monitor'
    import fileService from '../../service/file'
    import ECharts from '../../plugins/echarts'
    import moment from 'moment'
    import InfiniteLoading from 'vue-infinite-loading'
    import {mapGetters} from 'vuex'

    export default {
        name: "CompanyMonitorOverview",
        components: {PortalSection, 'v-chart': ECharts, InfiniteLoading},
        props: {
            searchParams: Object
        },
        data(){
            return {
                allMonitoredCompanySummaries: [],
                countEventAndCompanyMonthlyChart: null,
                companyRiskEvents:{
                    content: [],
                    number: -1,
                    totalPages: 0,
                    totalElements: 0,
                },
                relationCompanySummaries: null,
                infiniteId: 1
            }
        },
        watch:{
            searchParams:{
                handler(){
                    this.init()
                },
                deep: true
            }
        },
        computed: {
            ...mapGetters(['hasAuthority', 'hasAnyAuthority']),
            canAdmin(){
                return this.hasAuthority('P_前台_管理_风险监测')
            }
        },
        created(){
            this.init()
        },
        methods: {
            async init(){
                await this.listAllMonitoredCompanySummaries()
                await this.countEventAndCompanyMonthly()
                await this.listRelationCompanySummaries(1)
                this.infiniteId+=1
                this.companyRiskEvents={
                    content: [],
                    number: -1,
                    totalPages: 0,
                    totalElements: 0,
                }
            },
            async listAllMonitoredCompanySummaries(){
                // 获取当前时间段内关注公司的事件数
                let response = await companyMonitorService.listAllMonitoredCompanySummaries(this.searchParams)
                response.data.data.forEach(item=>{
                    if(item.companyLogo){
                        item.companyLogoUrl = fileService.getDpsFileUrl(item.companyLogo)
                    }
                })
                const allMonitoredCompanySummaries = response.data.data
                // 获取关注公司的全部事件数
                response = await companyMonitorService.listAllMonitoredCompanySummaries()
                allMonitoredCompanySummaries.forEach(item=>{
                    for(const matchedCompany of response.data.data){
                        if(item.companyId===matchedCompany.companyId){
                            item.totalEventCount = matchedCompany.eventCount
                            break
                        }
                    }
                })
                this.allMonitoredCompanySummaries = allMonitoredCompanySummaries
            },
            async countEventAndCompanyMonthly(){
                const response = await companyMonitorService.countEventAndCompanyMonthly(this.searchParams)
                const xAxisData = []
                const eventCountSeriesData = []
                const companyCountSerisData = []
                if(response.data.data.length>0){
                    const minTime = moment(response.data.data[0].key, 'YYYY-MM-DD')
                    const maxTime = moment(response.data.data[response.data.data.length-1].key, 'YYYY-MM-DD')
                    let dataIdx = 0
                    for(let time=minTime;time.isSameOrBefore(maxTime);time=time.add(1,'month')){
                        const timeStr = time.format('YYYY-MM-DD')
                        xAxisData.push(timeStr.substring(0,7))
                        const data = response.data.data[dataIdx]
                        if(data.key===timeStr){
                            eventCountSeriesData.push(data.value.eventCount)
                            companyCountSerisData.push(data.value.companyCount)
                            dataIdx++
                        }else{
                            eventCountSeriesData.push(0)
                            companyCountSerisData.push(0)
                        }
                    }

                }
                this.countEventAndCompanyMonthlyChart={
                    options: {
                        legend:{
                            show: true,
                            textStyle:{
                                color: '#D8D8DB'
                            }
                        },
                        tooltip: {
                            show: true,
                            trigger: 'axis'
                        },
                        toolbox: {
                            show: true,
                            feature: {
                                dataView: {readOnly: false},
                                saveAsImage: {}
                            }
                        },
                        xAxis: {
                            type: 'category',
                            axisLine:{
                                lineStyle:{
                                    color: '#6D6D77'
                                }
                            },
                            splitLine:{
                                show:false
                            },
                            data: xAxisData
                        },
                        yAxis: {
                            type: 'value',
                            minInterval: 1,
                            axisLine:{
                                lineStyle:{
                                    color: '#6D6D77'
                                }
                            },
                            splitLine:{
                                show:false
                            }
                        },
                        series: [
                            {
                                name:'事件数',
                                type: 'bar',
                                barMaxWidth: 40,
                                itemStyle: {
                                    color: '#6281D8'
                                },
                                data: eventCountSeriesData
                            },
                            {
                                name:'公司数',
                                type: 'bar',
                                barMaxWidth: 40,
                                itemStyle:{
                                    color:'#EE7B35'
                                },
                                data: companyCountSerisData
                            }
                        ]
                    },
                    initOptions: {}
                }
            },
            async loadCompanyRiskEvents($state){
                if(this.companyRiskEvents.number!==-1 && (this.companyRiskEvents.totalPages===0 ||
                    this.companyRiskEvents.number === this.companyRiskEvents.totalPages-1)){
                    $state.complete()
                    return
                }
                const response = await companyMonitorService.listCompanyRiskEvents(Object.assign({page: this.companyRiskEvents.number+1, size:10, sort: 'publishDate,desc'},this.searchParams))
                this.companyRiskEvents.content.push(...response.data.data.content)
                this.companyRiskEvents.number = response.data.data.number
                this.companyRiskEvents.totalPages = response.data.data.totalPages
                this.companyRiskEvents.totalElements = response.data.data.totalElements
                $state.loaded()
            },
            async listRelationCompanySummaries(page) {
                const params = Object.assign({page: page - 1, size: 10},this.searchParams)
                const response = await companyMonitorService.listRelationCompanySummaries(params)
                this.relationCompanySummaries = response.data.data
            },
            relationCompanySummariesIndexMethod(index) {
                return this.relationCompanySummaries.number * this.relationCompanySummaries.size + index + 1
            },
            showCompany(id) {
                companyMonitorService.openCompanyPage(id)
            },
            openEventPage(event){
                companyMonitorService.openEventPage(event)
            },
            async addMonitoredCompany(row){
                const response = await companyMonitorService.addMonitoredCompany({
                    companyId: row.relationCompanyId
                })
                if(!response.data.success){
                    this.$message({
                        type: 'error',
                        message: response.data.errorMsg
                    })
                    return
                }
                row.followed = true
            }
        }
    }
</script>

<style scoped>

</style>
